var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"head"}},[_c('h1',{staticClass:"uppercase"},[_vm._t("title",function(){return [_vm._v(_vm._s(_vm.title))]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }